export const stickerUploadDirectory = (
  stickerId: number,
  kind: 'main' | 'locked',
) =>
  [
    'stickers',
    process.env.REACT_APP_ENV === 'dev' ? 'dev' : '',
    String(stickerId),
    kind,
  ]
    .filter(Boolean)
    .join('/');
